import React from 'react';
import styled from 'styled-components';
import pj from '../../../package.json';

import StyledText from './StyledText';
import StyledAnchor from './StyledAnchor';
import { MOBILE_BREAKPOINT } from '../IntroPages/styles';

const VersionWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
`;

interface ContainerProps {
  $variant?: 'dark' | 'light';
}

const VersionContainer = styled.div<ContainerProps>`
  --container-bg: ${({ $variant }) => ($variant === 'dark' ? '#1A1A1A' : '#fff')};
  --font-color: ${({ $variant }) => ($variant === 'dark' ? '#fff' : 'inherit')};

  width: 532px;
  height: 66px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  background-color: var(--container-bg);
  border-radius: 4px;
  padding: 19px 31px;
  margin-top: 41px;

  gap: 29px;

  @media (max-width: ${MOBILE_BREAKPOINT}) {
    width: 100%;
    height: auto;
    gap: 12px;
  }
`;

interface VersionBannerProps {
  $variant?: 'dark' | 'light';
  style?: React.CSSProperties;
}

const VersionBanner = ({ $variant, style }: VersionBannerProps) => {
  const recentRelease = pj.dependencies['@carta/ink'];

  return (
    <VersionWrapper style={style}>
      <VersionContainer $variant={$variant} style={style}>
        <StyledText color={$variant === 'dark' ? 'white' : 'default'}>
          Ink version {recentRelease} has been released! 🎉
        </StyledText>
        <StyledAnchor
          href="#"
          onClick={() => window.location.reload()}
          variant={$variant === 'dark' ? 'dark' : 'default'}
        >
          Reload to update
        </StyledAnchor>
      </VersionContainer>
    </VersionWrapper>
  );
};

export default VersionBanner;
